import { makeStyles } from '@material-ui/core';

export const tourStyles = makeStyles({
  container: {
    marginTop: '0px !important',
    // paddingTop: '15px !important',
    paddingBottom: '15px !important',
  },
  buttonClose: {
    borderRadius: '50%',
    padding: 4,
    border: 0,
  },
  title: {
    textAlign: 'center',
  },
  content: {
    fontSize: '17px',
    marginBottom: '10px',
  },
  containerPaginacao: {
    width: '100%',
    textAlign: 'center',
    marginTop: '10px',
    marginBottom: '10px',
  },
  pontoPaginacao: {
    display: 'inline-block',
    width: '11px',
    height: '11px',
    margin: '0 5px',
    backgroundColor: '#c0c0c0',
    borderRadius: '10px',
  },
  elipsePaginacao: {
    display: 'inline-block',
    width: '25px',
    height: '11px',
    margin: '0 5px',
    backgroundColor: '#858585',
    borderRadius: '100px / 50px',
  },
  divider: {
    backgroundColor: 'rgba(0, 0, 0, 0.50)',
    marginBottom: '10px',
  },
  buttonVoltar: {
    backgroundColor: '#eee',
    border: '1px solid #5890AA',
    color: '#5890AA',
    width: 90,
    height: 30,
    borderRadius: 5,
    textTransform: 'none',
    marginRight: 'auto',
    marginLeft: '10px',
  },
  buttonProximo: {
    background: '#5890AA',
    color: '#fff',
    width: 90,
    height: 30,
    marginRight: '10px',
    borderRadius: 5,
    textTransform: 'capitalize',
    '&:hover': {
      background: '#2684AD',
    },
    float: 'right',
  },
});
